export const defaultSeName = 'main'
export const defaultParticipantsAges = [18, 18]
export const defaultCapacity = '2'
export const defaultStartDate = '2025-11-29' // business requirement. Should be set to 'null' or a date required by the business.
export const winterStartMonth = 12
export const nextSeasonButtonMonthStart = 0 // January
export const nextSeasonButtonMonthEnd = 10 // November